<template>
    <a-select :value="messageservicecode" placeholder="输入业务类型名称"  style="width: 150px"
         :filter-option="true" :not-found-content="null" 
        @change="handleChange">
        <a-select-option v-for="d in messageserviceList" :key="d.messageservicecode">
            {{ d.messageservicename }}
        </a-select-option>
    </a-select>

</template>
<script>
export default {
    data() {
        return {
            messageserviceList: [],
            messageservicecode: '',
        }
    },

    props: {
        channelcode: String,
        showAll:Boolean
    },

    methods: {

        handleChange(value) {
            this.messageservicecode = value
            let targetData = this.messageserviceList.filter((item) => {
                return item.messageservicecode == value
            });
            if (targetData.length > 0) {
                this.$emit('onmessageserviceCodeChange', targetData[0]);
            }
        },
        doSearch() {
            let that = this;
            let c_params = {
                urlparams: false,
                channelcode: this.channelcode,
            }

            that.$store.dispatch({
                type: "mcmsmanager/selectMcmsMessageServices",
                params: c_params,
                showMsg: false
            }).then((res) => {
                if (res.data.success == 1) {
                    that.messageserviceList = [];
                    if(that.showAll){
                        that.messageserviceList.push({
                            messageservicecode:'',
                            messageservicename:'全部'
                        });
                    }
                    let result = res.data.data;
                    if (!result) {
                        that.message.error("未查询到渠道");
                        return;
                    }
                    that.messageserviceList =  that.messageserviceList.concat(result) 
                    if(that.messageserviceList.length > 0){
                        that.messageservicecode = that.messageserviceList[0].messageservicecode
                        that.handleChange(that.messageservicecode)
                    }
                    else{
                        that.messageserviceList = [];
                        that.messageservicecode = ''
                        that.message.error("当前渠道没有可用业务类型！！")
                    }
                    this.$store.commit({
                        type: 'mcmsmanager/save',
                        payload: {
                            messageServiceList: result
                        }
                    })
                    
                }
            }).catch(() => {

            });
        },

    },
    mounted() {},
    watch: {
        'channelcode'(newVal) {
            if (newVal) {
                this.doSearch();
            }
        }
    },
};
</script>

<style scoped>

</style>